import * as React from "react";
import { useContext } from "react";
import PageMenuSwitch from "../../../Layout/PageMenu/PageMenuSwitch";
import { EditProjectContext } from "../EditProjectContext";

type Props = {
  disabled?: boolean;
};

export const ShowInOverviewSwitch = ({ disabled }: Props) => {
  const { project, setProject } = useContext(EditProjectContext);

  return (
    <PageMenuSwitch
      label="Show in Overview"
      value={project.ShowSpdrsInOverview ?? false}
      onChange={(value: boolean) => {
        setProject({ ...project, ShowSpdrsInOverview: value });
      }}
      disabled={disabled}
    />
  );
};
